<template>
    <page>
        <module enable-flex>
            <view-list ref="view" :work-type="10">
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="背贴码">
                            <m-code-batch-input name="produce_unique_codes" field-name="背贴码"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="IMEI">
                            <m-code-batch-input name="produce_imeis" field-name="IMEI"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="商户">
                            <c-select name="merchant_id" async @search="searchMerchant"></c-select>
                        </m-search-item>
                        <m-search-item label="商户名称">
                            <c-input name="merchant_name" placeholder="支持模糊查询"></c-input>
                        </m-search-item>
                        <m-search-item label="关键字">
                            <c-input name="keyword" placeholder="背贴码/IMEI"></c-input>
                        </m-search-item>
                        <m-search-item label="销售状态">
                            <c-select name="overall_state" :options="$store.state.saleOverallStateDic"></c-select>
                        </m-search-item>
                        <m-search-item label="操作时间" colspan="2">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <!--操作列：渠道状态核对（沿用核验权限点 b_erp_product_channel_verify）+ 四个只读记录入口（同商家端商品列表口径）-->
                <c-table-column type="button" label="操作" width="300" fixed="right" button-limit="6">
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_erp_product_channel_verify')" icon="tf-check" @click="openChannelVerify(data)">渠道核对</c-table-button>
                        <c-table-button icon="tf-detail" @click="viewPriceLog(data)">改价记录</c-table-button>
                        <c-table-button icon="tf-detail" @click="viewPushLog(data)">推送记录</c-table-button>
                        <c-table-button icon="tf-detail" @click="viewLendLog(data)">借出记录</c-table-button>
                        <c-table-button icon="tf-detail" @click="viewQualityReport(data)">质检报告</c-table-button>
                    </template>
                </c-table-column>

                <template #saas_info="{data}">
                    <div class="m-saas-info">
                        <p>{{data.saas_id || '-'}}</p>
                        <p class="m-saas-info-name">{{data.saas_name || '-'}}</p>
                    </div>
                </template>

                <template #product_info="{data}">
                    <m-product-info :name="data.product_info || getProductText(data)" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
                </template>

                <template #condition_info="{data}">
                    <div class="m-condition">
                        <p v-for="(item, i) in getConditionList(data)" :key="i">{{item}}</p>
                    </div>
                </template>

                <template #overall_state="{data}">
                    <span v-if="sourceHandoverStateText(data)" :style="{color: isSourceRejectPending(data) ? '#e53e3e' : ''}">{{sourceHandoverStateText(data)}}</span>
                    <!--是否展示销售主状态由服务端按版本能力下发（旗舰版要已接驳到销售区、门店版在库即看销售进度），端内不再硬编 state==32-->
                    <template v-else-if="data.show_sale_state">
                        <c-state dict="saleOverallStateDic" :value="data.overall_state"></c-state>
                    </template>
                    <!--处在其他状态，展示主状态-->
                    <template v-else>
                        <c-state dict="productStateDic" :value="data.state"></c-state>
                    </template>
                </template>

                <template #price_info="{data}">
                    <div class="m-price-info">
                        <p>成本价：{{formatPrice(data.cost_price)}}</p>
                        <p v-for="(item, i) in data.reference_price_list || []" :key="i">
                            {{item.platform_name}}参考价：{{formatPrice(item.sale_price)}}
                        </p>
                    </div>
                </template>

                <template #b_report_state="{data}">
                    <i v-if="data.b_report_state" class="tf-check tf" :class="qualityReportClass(data.b_report_state)"></i>
                </template>

                <template #c_report_state="{data}">
                    <i v-if="data.c_report_state" class="tf-check tf" :class="qualityReportClass(data.c_report_state)"></i>
                </template>

                <template #channel_list="{data}">
                    <div v-if="(data.channel_list || []).length" class="m-channel-lines">
                        <p v-for="(channel, i) in data.channel_list" :key="i">
                            <span>{{channel.channel_name}}：<span class="red">{{formatPrice(channel.sale_price)}}</span></span>
                            <!--服务端未下发 min_price（未维护控价比例）时标记；管理端仅展示，不含改价入口-->
                            <c-tooltip v-if="channelStateText(channel).tip" :tip="channelStateText(channel).tip">
                                <span :class="channelStateText(channel).cls">
                                    {{channelStateText(channel).text}}
                                </span>
                                <span class="m-channel-tip">!</span>
                                <template #tip>
                                    <p>{{channelStateText(channel).tip}}</p>
                                </template>
                            </c-tooltip>
                            <span v-else :class="channelStateText(channel).cls">
                                {{channelStateText(channel).text}}
                            </span>
                            <!--渠道动作（核对/校正/重置发布）统一挪到行“操作”列-->
                        </p>
                    </div>
                    <span v-else>-</span>
                </template>

                <template #is_dismantle="{data}">
                    <span v-if="data.is_dismantle==1" class="m-dismantle-tag" title="已拆机">拆</span>
                    <span v-else>-</span>
                </template>

                <template #state="{data}">
                    <c-state async dict="UNIQUE_CODE_STATE" tag :value="data.state"></c-state>
                </template>

                <template #is_demo="{data}">
                    <c-state dict="yesOrNoOptions" :value="data.is_demo"></c-state>
                </template>

                <!--是否借出：借出为虚拟状态不改条码/商品字段，服务端按借出台账未归还明细判定为 1-是 2-否-->
                <template #is_lend="{data}">
                    <c-state dict="yesOrNoOptions" :value="data.is_lend"></c-state>
                </template>

                <template #produce_unique_code="{data}">
                    {{data.produce_unique_code}} <c-link v-if="data.produce_unique_code" color="gray" @click="$copy(data.produce_unique_code)"><i class="tf">&#xe6b0;</i></c-link>
                </template>

                <template #produce_imei="{data}">
                    {{data.produce_imei}} <c-link v-if="data.produce_imei" color="gray" @click="$copy(data.produce_imei)"><i class="tf">&#xe6b0;</i></c-link>
                </template>

                <template #cost_price="{data}">
                    {{formatPrice(data.cost_price)}}
                </template>

                <template #retail_price="{data}">
                    {{formatPrice(data.retail_price)}}
                </template>

                <template #repair_cost="{data}">
                    {{formatPrice(data.repair_cost)}}
                </template>

                <template #stock_days="{data}">
                    <span :style="{color: stockAgeColor(data.stock_days)}">{{formatDay(data.stock_days)}}</span>
                </template>

                <template #transit_days="{data}">
                    <span :style="{color: data.transit_days > 2 ? '#e53e3e' : ''}">{{formatDay(data.transit_days)}}</span>
                </template>
            </view-list>
            <!--四个只读记录弹窗（数据与样式同商家端商品列表，接口走运营端薄封装按商户切租户）-->
            <sale-price-log-dialog ref="priceLog"></sale-price-log-dialog>
            <sale-push-log-dialog ref="pushLog"></sale-push-log-dialog>
            <sale-lend-log-dialog ref="lendLog"></sale-lend-log-dialog>
            <quality-report-view ref="qualityReport"></quality-report-view>
            <!--渠道状态核对差异报告：逐渠道列出本地/真实状态与结论，不一致可就地校正-->
            <c-dialog ref="verifyDialog" title="渠道状态核对" width="1000">
                <div class="m-verify-body">
                    <div class="m-verify-head">商品：{{ (verifyProduct && verifyProduct.produce_unique_code) || '-' }}</div>
                    <table class="m-verify-table">
                        <thead>
                            <tr><th>渠道</th><th>本地状态</th><th>渠道真实状态</th><th>核对结论</th><th>操作</th></tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, i) in verifyRows" :key="i">
                                <td>{{ row.channel_name || ('渠道' + row.channel_id) }}</td>
                                <td><span :class="channelStateText(row).cls">{{ channelStateText(row).text }}</span></td>
                                <td>{{ row.status_desc || row.channel_status || '-' }}</td>
                                <td>
                                    <span :class="verifyResultClass(row.verify_result)">{{ verifyResultText(row.verify_result) }}</span>
                                    <p v-if="row.message" class="m-verify-msg">{{ row.message }}</p>
                                </td>
                                <td>
                                    <c-button v-if="row.verify_result === 'INCONSISTENT'" size="small" color="main" @click="correctChannel(row)">校正</c-button>
                                    <c-link v-if="canResetPublish(row)" color="gray" @click="resetChannelPublish(row)">重置发布</c-link>
                                    <span v-if="row.verify_result !== 'INCONSISTENT' && !canResetPublish(row)">-</span>
                                </td>
                            </tr>
                            <tr v-if="!verifyRows.length"><td colspan="5" class="m-verify-empty">该商品暂无渠道记录</td></tr>
                        </tbody>
                    </table>
                </div>
            </c-dialog>
        </module>
    </page>
</template>

<script>
import SalePriceLogDialog from './components/sale_price_log_dialog.vue';
import SalePushLogDialog from './components/sale_push_log_dialog.vue';
import SaleLendLogDialog from './components/sale_lend_log_dialog.vue';
import QualityReportView from './components/quality_report_view.vue';

export default {
    name: 'erp_product_list',
    components: {
        SalePriceLogDialog,
        SalePushLogDialog,
        SaleLendLogDialog,
        QualityReportView
    },
    data() {
        return {
            /*********库龄颜色配置（图例与列表分色同源驱动）**********/
            stockAgeColors: [
                {min: 1, max: 7, color: '#333', label: '1-7天'},
                {min: 8, max: 15, color: '#2b7be4', label: '8-15天'},
                {min: 16, max: 30, color: '#cc00ff', label: '16-30天'},
                {min: 31, max: 60, color: '#ff9900', label: '30天-60天'},
                {min: 61, max: null, color: '#ed3f14', label: '60天以上'}
            ],
            /*********渠道状态核对差异报告弹框数据**********/
            verifyProduct: {},//当前核对的商品行
            verifyRows: []//核对结论逐渠道明细
        };
    },
    methods: {
        searchMerchant(keyword, resolve) {
            this.request({url: '/sys_saas/options', data: {keyword}, success: resolve});
        },
        /*********来源接驳状态文字（已调出/调拨中/被驳回中/已返库；运营端跨商户列表无页面级接驳版本开关，按服务端逐行下发的 handover_state 展示）**********/
        sourceHandoverStateText(data) {
            return {6: '已调出', 8: '调拨中', 9: '被驳回中', 5: '已返库'}[data.handover_state] || '';
        },
        /*********来源接驳是否被驳回中（被驳回中红色标记）**********/
        isSourceRejectPending(data) {
            return Number(data.handover_state) === 9;
        },
        /*********格式化价格**********/
        formatPrice(price) {
            if (price === null || price === undefined || price === '') return '-';
            return '¥' + parseFloat(price).toFixed(2);
        },
        /*********格式化天数**********/
        formatDay(day) {
            if (day === null || day === undefined || day === '') return '-';
            return parseInt(day) + '天';
        },
        /*********库龄分档颜色（按stockAgeColors配置匹配区间）**********/
        stockAgeColor(day) {
            if (day === null || day === undefined || day === '') return '';
            var age = parseInt(day);
            if (isNaN(age)) return '';
            for (var i = 0; i < this.stockAgeColors.length; i++) {
                var item = this.stockAgeColors[i];
                if (age >= item.min && (item.max === null || age <= item.max)) return item.color;
            }
            return '';
        },
        /*********获取产品信息文字**********/
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.model_name) parts.push(data.model_name);
            if (data.memory_name) parts.push(data.memory_name);
            if (data.color_name) parts.push(data.color_name);
            return parts.join(' ') || '-';
        },
        /*********获取成色列表（成色按参考渠道展示）**********/
        getConditionList(data) {
            var list = [];
            if (data.condition_list && data.condition_list.length) {
                data.condition_list.forEach(item => {
                    if (item.channel_name && item.level_name) {
                        list.push(item.channel_name + '：' + item.level_name);
                    }
                });
            }
            return list.length ? list : ['-'];
        },
        /*********质检报告状态样式（0不展示，1待发布橙色，2已发布绿色，3已下架红色）**********/
        qualityReportClass(val) {
            return {1: 'm-quality-pending', 2: 'm-quality-published', 3: 'm-quality-offshelf'}[val] || '';
        },
        /*********渠道不能上架的原因（对齐后端 batchOnShelf 的可上架判据，返回空表示无阻碍）**********/
        channelShelfWarn(channel) {
            if (channel.channel_publish_state && channel.channel_publish_state != 2) return '商品未发布';
            if (!(channel.sale_price > 0)) return '该渠道未设置售价';
            return '';
        },
        /*********渠道状态展示（基于 sync_state + sync_type + listing_state）**********/
        channelStateText(channel) {
            const ss = channel.sync_state;
            const st = channel.sync_type;
            const ls = channel.listing_state;
            const opName = {1: '发布', 2: '上架', 3: '下架', 4: '调价', 5: '信息更新', 6: '售出下架', 7: '锁单下架', 8: '退货退款恢复'}[st] || '操作';
            /**业务终态优先于传输进度态：已售出/下单锁定是订单在本渠道落定的事实态，不被 sync 进度（待推送/推送中/推送失败）盖过*/
            if (ls === 4) {
                return { text: '已售出', tip: '', cls: 'm-state-on' };
            }
            if (ls === 5) {
                return { text: '锁定中', tip: '', cls: 'm-state-syncing' };
            }
            if (ss === 1) {
                /**本地已下架且待推送的是下架类任务：如实展示已下架，不再误显「待推送」；上架任务(st=2)除外*/
                if (ls === 3 && st !== 2) {
                    return { text: '已下架', tip: '', cls: 'm-state-default' };
                }
                return { text: '待推送', tip: '', cls: '' };
            }
            if (ss === 2) {
                /**需审批渠道（转转严选）发布受理后停在同步中，后端将审核过程状态写入 sync_fail_reason（进入同步中时已清空旧值，非空即审核中），
                 * 界面直接展示「上架中，需质检」，后端原始进展说明收在悬浮；无说明则回落通用「推送中」*/
                if (channel.sync_fail_reason) {
                    return { text: '上架中，需质检', tip: channel.sync_fail_reason, cls: 'm-state-syncing' };
                }
                return { text: '推送中', tip: '正在' + opName, cls: 'm-state-syncing' };
            }
            if (ss === 4) {
                return { text: '推送失败', tip: opName + '失败：' + (channel.sync_fail_reason || ''), cls: 'm-state-fail' };
            }
            const listingText = {1: '待上架', 2: '已上架', 3: '已下架'}[ls] || '-';
            const listingCls = ls === 2 ? 'm-state-on' : 'm-state-default';
            const shelfTip = (ls === 1 || ls === 3) ? this.channelShelfWarn(channel) : '';
            return { text: listingText, tip: shelfTip, cls: listingCls };
        },
        /*********记录弹窗入参：补商品信息文字，其余行字段原样带入（saas_id 供后端按商户切租户）**********/
        recordParams(data) {
            return Object.assign({}, data, {product_info: data.product_info || this.getProductText(data)});
        },
        /*********改价记录**********/
        viewPriceLog(data) {
            this.$refs.priceLog.open(this.recordParams(data));
        },
        /*********推送记录**********/
        viewPushLog(data) {
            this.$refs.pushLog.open(this.recordParams(data));
        },
        /*********借出记录**********/
        viewLendLog(data) {
            this.$refs.lendLog.open(this.recordParams(data));
        },
        /*********质检报告：列表行下发的是条码ID，弹窗按 product_code_id 查询**********/
        viewQualityReport(data) {
            this.$refs.qualityReport.open(Object.assign(this.recordParams(data), {
                product_code_id: data.produce_unique_code_id
            }));
        },
        /*********商品级渠道状态核对：一次拉取该商品全部渠道真实状态差异报告（只读预览、不落库），弹框逐渠道处理**********/
        openChannelVerify(data) {
            this.verifyProduct = data;
            this.verifyRows = [];
            this.request({
                url: '/sale/product/ops/verifyProductChannels',
                data: {saas_id: data.saas_id, product_id: data.id},
                loading: true,
                success: (rows) => {
                    this.verifyRows = Array.isArray(rows) ? rows : [];
                    this.$refs.verifyDialog.open();
                }
            });
        },
        /*********单渠道校正：按渠道真实状态落定本地 listing_state（复用单渠道核验写侧，不带 dry_run 即写），成功后就地回写该行并刷新列表**********/
        correctChannel(row) {
            this.$confirm({
                message: '确认按渠道真实状态校正【' + (row.channel_name || '') + '】吗？将把本地状态落定为' + (row.after_listing_state === 3 ? '已下架' : '在售'),
                buttonName: '确认校正',
                cancelButton: true,
                resolve: () => {
                    this.request({
                        url: '/sale/product/ops/syncChannelState',
                        data: {saas_id: this.verifyProduct.saas_id, product_id: this.verifyProduct.id, channel_id: row.channel_id},
                        loading: true,
                        success: (result) => {
                            if (result) {
                                if (result.after_listing_state !== null && result.after_listing_state !== undefined) row.listing_state = result.after_listing_state;
                                if (result.verify_result) row.verify_result = result.verify_result;
                                if (result.status_desc) row.status_desc = result.status_desc;
                                if (result.message) row.message = result.message;
                            }
                            this.$message({message: (result && result.message) || '校正完成', type: 'success'});
                            this.$refs.view.refresh();
                        }
                    });
                }
            });
        },
        /*********核对结论短文字（差异报告用；CORRECTED 为校正写侧回传）**********/
        verifyResultText(val) {
            return {CONSISTENT: '一致', INCONSISTENT: '待校正', CORRECTED: '已校正', SKIPPED: '已跳过', UNRECOGNIZED: '未识别', ERROR: '核对失败'}[val] || '-';
        },
        /*********核对结论配色**********/
        verifyResultClass(val) {
            if (val === 'CONSISTENT' || val === 'CORRECTED') return 'm-verify-ok';
            if (val === 'INCONSISTENT') return 'm-verify-warn';
            if (val === 'ERROR' || val === 'UNRECOGNIZED') return 'm-verify-fail';
            return 'm-verify-skip';
        },
        /*********是否展示“重置发布”入口（软门，与后端硬护栏同源；后端为真相）**********/
        canResetPublish(channel) {
            if (!this.auth('b_erp_product_channel_reset')) return false;
            const ps = channel.channel_publish_state;
            const ls = channel.listing_state;
            const ss = channel.sync_state;
            //有发布身份可废（发布态非空且非0）
            if (!ps || ps === 0) return false;
            //非在售且非终态：仅未上架(1)/已下架(3)
            if (ls !== 1 && ls !== 3) return false;
            //无待处理/在途任务：sync_state 为空或 3(成功)/4(失败)
            if (ss !== null && ss !== undefined && ss !== 3 && ss !== 4) return false;
            return true;
        },
        /*********重置渠道发布状态（破坏性动作，二次确认后提交；只清发布身份，成功后就地置发布态为0收起入口）**********/
        resetChannelPublish(row) {
            this.$confirm({
                message: '确认重置渠道【' + (row.channel_name || '') + '】的发布状态吗？将废除该渠道旧商品，商品重新上架时会重新发布并携带最新质检报告',
                buttonName: '确认重置',
                cancelButton: true,
                resolve: () => {
                    this.request({
                        url: '/sale/product/ops/resetChannelPublish',
                        data: {saas_id: this.verifyProduct.saas_id, product_id: this.verifyProduct.id, channel_id: row.channel_id},
                        loading: true,
                        success: (result, msg) => {
                            row.channel_publish_state = 0;
                            row.sync_fail_reason = '';
                            this.$message({message: msg || '重置成功', type: 'success'});
                            this.$refs.view.refresh();
                        }
                    });
                }
            });
        }
    }
};
</script>

<style scoped>
.m-condition {line-height: 20px; font-size: 13px; color: #333;}
.m-price-info {line-height: 20px; font-size: 13px; color: #333;}
.m-quality-pending {color: #e6a23c; font-size: 20px; font-weight: bold;}
.m-quality-published {color: #19be6b; font-size: 20px; font-weight: bold;}
.m-quality-offshelf {color: #ed3f14; font-size: 20px; font-weight: bold;}
.m-channel-lines p {display: flex; align-items: center; gap: 8px; line-height: 20px; white-space: nowrap; margin: 0;}
.m-channel-lines .m-state-on {color: #19be6b;}
.m-channel-lines .m-state-syncing {color: #e6a23c; display: inline-flex; align-items: center; gap: 4px;}
.m-channel-lines .m-state-fail {color: #999; display: inline-flex; align-items: center; gap: 4px;}
.m-channel-lines .m-state-default {color: #999;}
.m-channel-lines .m-channel-tip {display: inline-flex; align-items: center; justify-content: center; width: 16px; height: 16px; border: 1.5px solid #ed3f14; border-radius: 50%; color: #ed3f14; font-size: 12px; font-weight: bold; margin-left: 4px; cursor: pointer; line-height: 1;}
.m-channel-lines .m-channel-verify {color: #2b7be4; font-size: 12px;}
.m-channel-lines .red {color: red; font-weight: bold;}
.m-saas-info {line-height: 20px; font-size: 13px; color: #333;}
.m-saas-info p {margin: 0;}
.m-saas-info-name {color: #999; font-size: 12px;}
.m-dismantle-tag {display: inline-flex; align-items: center; justify-content: center; width: 24px; height: 24px; border: 1.5px solid #ed3f14; border-radius: 50%; color: #ed3f14; font-size: 13px; font-weight: bold;}
/* 渠道状态核对差异报告弹框 */
.m-verify-body {padding: 20px 24px;}
.m-verify-head {margin-bottom: 12px; font-size: 13px; color: #333;}
.m-verify-table {width: 100%; border-collapse: collapse; font-size: 13px;}
.m-verify-table th, .m-verify-table td {border: 1px solid #ebeef5; padding: 8px 10px; text-align: left; vertical-align: middle;}
.m-verify-table th {background: #fafafa; color: #666; font-weight: bold;}
.m-verify-msg {margin: 4px 0 0; font-size: 12px; color: #999; line-height: 18px;}
.m-verify-ok {color: #19be6b;}
.m-verify-warn {color: #e6a23c; font-weight: bold;}
.m-verify-fail {color: #ed3f14;}
.m-verify-skip {color: #999;}
.m-verify-empty {text-align: center; color: #999;}
</style>
